import React from "react";

export default function Sidebar({
  isOpen,
  setIsOpen,
  onLogout,
  setView,
  userProfilePic,
}) {
  const navigate = (viewName) => {
    setView(viewName);
    setIsOpen(false);
  };

  return (
    <>
      <div
        className={`fixed inset-0 bg-slate-950/40 backdrop-blur-sm z-[100] transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setIsOpen(false)}
      ></div>

      <aside
        className={`fixed left-0 top-0 h-screen w-72 bg-white dark:bg-slate-900 border-r border-slate-100 dark:border-slate-800 transition-transform duration-500 ease-in-out z-[110] flex flex-col p-6 ${
          isOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"
        }`}
      >
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-3 mb-10 px-2">
            <img
              src={userProfilePic || "https://ui-avatars.com/api/?name=User"}
              className="w-10 h-10 rounded-xl object-cover border-2 border-indigo-600"
              alt="Profile"
            />
            <span className="font-black text-xl dark:text-white tracking-tight">
              Task Tracker
            </span>
          </div>

          <button
            onClick={() => navigate("dashboard")}
            className="w-full flex items-center gap-4 p-4 rounded-2xl hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold transition-all"
          >
            <i className="fas fa-th-large text-xl"></i>
            <span>Dashboard</span>
          </button>

          <button
            onClick={() => navigate("profile")}
            className="w-full flex items-center gap-4 p-4 rounded-2xl hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold transition-all"
          >
            <i className="fas fa-user-circle text-xl"></i>
            <span>My Profile</span>
          </button>
        </div>

        <div className="border-t border-slate-100 dark:border-slate-800 pt-6 pb-4">
          <button
            onClick={onLogout}
            className="w-full flex items-center gap-4 p-4 rounded-2xl text-slate-400 hover:text-red-500 transition-all"
          >
            <i className="fas fa-sign-out-alt text-xl"></i>
            <span className="font-black text-sm">Log Out</span>
          </button>
        </div>
      </aside>
    </>
  );
}
